// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tip-component {
  color: var(--color-black);
  padding: 0px;
  border-radius: 0px;
}

.title {
  font-family: Montserrat, sans-serif;
  font-size: 18px;
  line-height: 20px;
  font-weight: 700;
  letter-spacing: 0em;
  text-align: left;
  color: #fff;
  margin-right: 10px;
  text-transform: uppercase;
}

.chip {
  width: -moz-fit-content;
  width: fit-content;
  font-size: 10px;
  line-height: 12px;
  letter-spacing: 0em;
  text-align: left;
  text-transform: uppercase;
  border-radius: 16px;
}

.tip-img {
  height: 20px;
}

.tip {
  padding: 5px;
  margin-right: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: transparent;
  border-radius: 8px;
  height: 60px;
  font-family: AppFontBold, sans-serif;
  border: 1px solid var(--accent-color);
  flex-direction: column-reverse;
}
.tip p {
  color: #fff;
  margin-top: 5px;
}
.tip .sum {
  font-family: AppFontMedium, sans-serif;
  font-size: 12px;
  line-height: 19px;
  font-weight: 700;
  letter-spacing: 0em;
  text-align: center;
  text-transform: uppercase;
}
.tip:last-of-type {
  margin-right: 0;
}
.tip.selected {
  background: var(--accent-color);
}
.tip.selected .sum {
  color: white;
}

.custom-tip-row {
  justify-content: space-between;
}
.custom-tip-row ion-icon {
  cursor: pointer;
}

.custom {
  display: flex;
  justify-content: flex-end;
  cursor: pointer;
}

.titles-wrapper {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 12px 0;
}
.titles-wrapper p {
  margin-left: auto;
}`, "",{"version":3,"sources":["webpack://./src/app/components/tip/tip.component.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,YAAA;EACA,kBAAA;AACF;;AAMA;EACE,mCAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;AAHF;;AAMA;EACE,uBAAA;EAAA,kBAAA;EAEA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;AAJF;;AAOA;EACE,YAAA;AAJF;;AAOA;EACE,YAAA;EACA,iBAAA;EACA,aAAA;EAEA,uBAAA;EACA,mBAAA;EAEA,uBAAA;EACA,kBAAA;EACA,YAAA;EACA,oCAAA;EACA,qCAAA;EACA,8BAAA;AANF;AAOE;EACE,WAAA;EACA,eAAA;AALJ;AASE;EACE,sCAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;AAPJ;AAUE;EACE,eAAA;AARJ;AAWE;EACE,+BAAA;AATJ;AAWI;EACE,YAAA;AATN;;AAcA;EACE,8BAAA;AAXF;AAaE;EACE,eAAA;AAXJ;;AAeA;EACE,aAAA;EACA,yBAAA;EACA,eAAA;AAZF;;AAeA;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,eAAA;AAZF;AAcE;EACE,iBAAA;AAZJ","sourcesContent":[".tip-component {\n  color: var(--color-black);\n  padding: 0px;\n  border-radius: 0px;\n}\n\n.title-row {\n\n}\n\n.title {\n  font-family: Montserrat, sans-serif;\n  font-size: 18px;\n  line-height: 20px;\n  font-weight: 700;\n  letter-spacing: 0em;\n  text-align: left;\n  color: #fff;\n  margin-right: 10px;\n  text-transform: uppercase;\n}\n\n.chip {\n  width: fit-content;\n\n  font-size: 10px;\n  line-height: 12px;\n  letter-spacing: 0em;\n  text-align: left;\n  text-transform: uppercase;\n  border-radius: 16px;\n}\n\n.tip-img {\n  height: 20px;\n}\n\n.tip {\n  padding: 5px;\n  margin-right: 5px;\n  display: flex;\n\n  justify-content: center;\n  align-items: center;\n\n  background: transparent;\n  border-radius: 8px;\n  height: 60px;\n  font-family: AppFontBold, sans-serif;\n  border: 1px solid var(--accent-color);\n  flex-direction: column-reverse;\n  p {\n    color: #fff;\n    margin-top: 5px;\n  }\n\n\n  .sum {\n    font-family: AppFontMedium, sans-serif;\n    font-size: 12px;\n    line-height: 19px;\n    font-weight: 700;\n    letter-spacing: 0em;\n    text-align: center;\n    text-transform: uppercase;\n  }\n\n  &:last-of-type {\n    margin-right: 0;\n  }\n\n  &.selected {\n    background: var(--accent-color);\n\n    .sum {\n      color: white;\n    }\n  }\n}\n\n.custom-tip-row {\n  justify-content: space-between;\n\n  ion-icon {\n    cursor: pointer;\n  }\n}\n\n.custom {\n  display: flex;\n  justify-content: flex-end;\n  cursor: pointer;\n}\n\n.titles-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  padding: 12px 0;\n\n  p {\n    margin-left: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
